import { computed, createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    compilerOptions: {
      // register any non-vue custom elements we can use inside this app
      isCustomElement: (tag) => ["g-map-2", "g-marker"].includes(tag),
    },    
    props: [
      'el'
    ],
    data(){
      return {
        loading: false,
        items: [],
        perPage: 12,
        totalItems: 1,
        maxPages: 1,
        postTypeLabel: 'Post',
        postType: 'post',
        filters: [],
        mapShowing: false,
        filtersShowing: false,
        prefilterCategoryId: null,
        // form data
        page: 1,
        search: '',
        startDate: new Date().toISOString().split('T')[0],
        endDate: '',
        selectedTerms: {},
        ariaAnnouncement: '',
        fetchOnClose: false,
        sort: 'rand',
      }
    },
    mounted(){
      // localize data from PHP
      this.postTypeLabel = this.el.getAttribute('data-post-type-name') || 'Post'
      this.postType = this.el.getAttribute('data-post-type') || 'post'
      this.prefilterCategoryId = this.el.hasAttribute('data-prefilter-category') ? parseInt(this.el.getAttribute('data-prefilter-category')) : null
      this.filters = JSON.parse(this.el.getAttribute('data-filters') || [])

      // initialize data
      this.resetFilters()

      // start the app
      if(window.coolHelperFunctions.getURLParam('quick-date')){
        this.setDatesByPresetAndFetch(window.coolHelperFunctions.getURLParam('quick-date'))
      } else {
        const wasHistoryPulled = this.pullHistory()
        this.fetchItems(false, wasHistoryPulled)
      }

      // auto close filters when clicking outside the form
      document.addEventListener('click', e => {
        if(this.filtersShowing && !this.$refs.form?.contains(e.target)){
          this.filtersShowing = false
        }
      })
      document.addEventListener('focusin', e => {
        if(this.filtersShowing && !this.$refs.form?.contains(e.target)){
          this.filtersShowing = false
        }
      })      
    },
    watch: {
      filtersShowing(val){
        if(!val && this.fetchOnClose){
          this.fetchItems(true, true)
        }
      }
    },
    methods: {
      formatDate(d){
        const date = new Date(d)
        const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000)
        const mm = String(localDate.getMonth() + 1).padStart(2, '0')
        const dd = String(localDate.getDate()).padStart(2, '0')
        const yyyy = localDate.getFullYear()
        return `${mm}/${dd}/${yyyy}`
      },
      removeTerm(term) {
        this.filters.forEach(f => {
          const slug = f.taxonomy.slug
          if (this.selectedTerms[slug]?.some(id => id == term.id)) {
            this.selectedTerms[slug] = this.selectedTerms[slug].filter(id => id != term.id)
          }
        })
        this.setPage(1)
      },
      setAriaAnnouncement(){
        this.ariaAnnouncement = {
          search: this.search,
          filters: Object.entries(this.selectedTerms)
            .filter(([_, terms]) => terms.length)
            .map(([taxonomySlug, termIds]) => {
              const filterObj = this.filters.find(f => f?.taxonomy?.slug === taxonomySlug)
              return {
                taxonomy: filterObj?.taxonomy?.name || taxonomySlug,
                terms: termIds.map(id => {
                  const term = filterObj?.terms?.find(t => t.term_id == id)
                  return { id: term?.term_id, name: term?.name }
                })
              }
            }),
          startDate: this.startDate,
          endDate: this.endDate,
          postType: this.postType,
          pagination: this.items.length
            ? {
                start: this.page == this.maxPages
                  ? this.totalItems - this.items.length + 1
                  : 1 + (this.items.length * (this.page - 1)),
                end: this.page == this.maxPages
                  ? this.totalItems
                  : this.items.length * this.page,
                total: this.totalItems
              }
            : null
        }
      },
      resetFilters(){
        this.filters.forEach(filter => {
          this.selectedTerms[filter.taxonomy.slug] = []
        })
        this.startDate = new Date().toISOString().split('T')[0]
        this.endDate = ''
      },
      setPage(page){
        this.page = parseInt(page)
        this.fetchItems(false, true)
      },
      clearAllFiltersAndReset(){
        this.filtersShowing = false
        this.resetFilters()
        this.setPage(1)
      },
      getPrefilterTaxonomySlug(){
        let found = null
        this.filters.forEach(filter => {
          const containsPrefilter = filter.terms.some(t => t.term_id == this.prefilterCategoryId)
          if(containsPrefilter){
            found = filter.taxonomy.slug
          }
        })
        return found
      },
      getValidFilterTerms(filter){
        let terms = JSON.parse(JSON.stringify(filter.terms))
        const containsPrefilterAsParent = terms.some(t => t.parent_id == this.prefilterCategoryId)
        const containsPrefilterAsChild = terms.some(t => t.term_id == this.prefilterCategoryId)
        if(containsPrefilterAsParent){
          terms = terms.filter(t => t.parent_id == this.prefilterCategoryId)
        } else if(containsPrefilterAsChild){
          terms = []
        }
        return terms
      },
      fetchItems(resetPage, setFocus){

        this.fetchOnClose = false

        if(resetPage){
          this.page = 1
        }

        this.loading = true
        this.setAriaAnnouncement()

        // automatically inject the prefilter category
        const filters = JSON.parse(JSON.stringify(this.selectedTerms))
        if(this.prefilterCategoryId){
          if(!this.getPrefilterTaxonomySlug()){
            console.warn(this.prefilterCategoryId, 'no matching taxonomy slug??')
          }
          filters[this.getPrefilterTaxonomySlug()].push(this.prefilterCategoryId)
        }

        window.coolHelperFunctions.coolAjax({
          action: 'fetch_grand_haven_post_listing',
          post_type: this.postType,
          page: this.page,
          per_page: this.perPage,
          search: this.search,
          sort: this.sort,
          start_date: this.startDate,
          end_date: this.endDate,
          filters: filters
        }, json => {
          this.loading = false
          this.items = json.items
          this.totalItems = json.totalItems
          this.maxPages = json.maxPages
          this.setAriaAnnouncement()

          this.pushHistory()
          
          this.$nextTick(() => {
            if(setFocus){
              this.$refs.ariaAnnouncement?.focus()
            }
          })
        }, err => {
          this.loading = false
          this.setAriaAnnouncement()
          alert(`Something went wrong. Please try again later. ${err}`)
        })
      },
      pushHistory(){
        const params = new URLSearchParams()

        if (this.page && this.page > 1) params.set('page', this.page)
        if (this.search) params.set('search', this.search)       
        if(this.postType == 'events'){
          const today = new Date().toISOString().slice(0, 10)
          if (this.startDate && this.startDate !== today) {
            params.set('startDate', this.startDate)
          }
          if (this.endDate) params.set('endDate', this.endDate)
        }

        Object.entries(this.selectedTerms).forEach(([taxonomy, terms]) => {
          if (terms.length) {
            // adding a _ in front of the slug so WP's standard taxonomy query var functionality doesn't get screwy
            params.append(`_${taxonomy}`, terms.join(','))
          }
        })

        if (params.toString()) {
          const newUrl = `${window.location.pathname}?${params.toString()}`
          if(window.location.href != newUrl){
            window.history.replaceState({}, '', newUrl)
          }
        }

      },
      pullHistory() {
        let updated = false
        const params = new URLSearchParams(window.location.search)

        if (params.has('page')) {
          this.page = parseInt(params.get('page'))
          updated = true
        }

        if (params.has('search')) {
          this.search = params.get('search')
          updated = true
        }

        if (params.has('startDate')) {
          this.startDate = params.get('startDate')
          updated = true
        }

        if (params.has('endDate')) {
          this.endDate = params.get('endDate')
          updated = true
        }

        Object.keys(this.selectedTerms).forEach(taxonomy => {
          const val = params.get(`_${taxonomy}`)
          this.selectedTerms[taxonomy] = val ? val.split(',') : []
          if (val !== null) updated = true
        })

        return updated
      },
      setDatesByPresetAndFetch(preset) {
        const today = new Date()
        let startDate, endDate

        switch(preset) {
          case 'today':
            startDate = endDate = today.toISOString().slice(0, 10)
            break

          case 'week':
            const weekLater = new Date(today)
            weekLater.setDate(today.getDate() + 6)
            startDate = today.toISOString().slice(0, 10)
            endDate = weekLater.toISOString().slice(0, 10)
            break

          case 'weekend':
            const day = today.getDay()
            const fridayOffset = day <= 5 ? 5 - day : 0 // if Friday or before, get to Friday; else 0 (already weekend)
            const friday = new Date(today)
            friday.setDate(today.getDate() + fridayOffset)
            const sunday = new Date(friday)
            sunday.setDate(friday.getDate() + 2) // Friday + 2 = Sunday
            startDate = friday.toISOString().slice(0, 10)
            endDate = sunday.toISOString().slice(0, 10)
            break
        }

        this.startDate = startDate
        this.endDate = endDate
        this.fetchItems(true, true)
      },      
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.grand-haven-post-listing--app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}